export default {
    methods: {
        ImageAsset(filename) { return `${process.env.BASE_URL}images/${filename}`; },
        FileAsset(filename) { return `${process.env.BASE_URL}assets/${filename}`; }
    }
};